// app/row-value.ts — чтение и запись значений строки по ключу и по пути вида `a.b.c`.

import { isRecord } from "./is-record";

export function getRowValue(row: unknown, key: string): unknown {
  if (typeof row !== "object" || row === null || Array.isArray(row)) {
    return undefined;
  }
  return Reflect.get(row, key);
}

export function getNestedValue(obj: unknown, path: string): unknown {
  return path
    .split(".")
    .reduce<unknown>((acc, key) => (isRecord(acc) ? acc[key] : undefined), obj);
}

export function setNestedValue(
  obj: Record<string, unknown>,
  path: string,
  value: unknown,
): Record<string, unknown> {
  const keys = path.split(".");
  const result = { ...obj };
  let cursor: Record<string, unknown> = result;
  for (let i = 0; i < keys.length - 1; i++) {
    const key = keys[i]!;
    const nested = isRecord(cursor[key]) ? cursor[key] : {};
    const next = { ...nested };
    cursor[key] = next;
    cursor = next;
  }
  cursor[keys[keys.length - 1]!] = value;
  return result;
}
